export type Product = {
  name?: string
  description?: string
  images?: string[] // URLs to product images
  sku?: string
  mpn?: string
  brand?: string
  url?: string
  currency?: string // ISO 4217 (e.g. "USD")
  price?: string | number
  color?: string
}

type Props = Product

export function ProductJsonLd({ ...product }: Props) {
  const jsonLd = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: product.name,
    image: product.images,
    description: product.description,
    color: product.color,
    sku: product.sku,
    mpn: product.mpn,
    brand: { '@type': 'Brand', name: product.brand },
    offers: {
      '@type': 'Offer',
      url: product.url,
      priceCurrency: product.currency,
      price: product.price,
      itemCondition: 'https://schema.org/NewCondition',
      availability: 'https://schema.org/InStock',
    },
  }

  return (
    <script type="application/ld+json">
      {JSON.stringify(jsonLd, null, 2)}
    </script>
  )
}
